export default function selectTrelloMembersById(state) {
  return state.integrations.thirdPartyData.trello.members
}
